var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.resolvedLayout,{tag:"component",staticClass:"site"},[(!_vm.showServiceFail)?_c('router-view'):_vm._e(),_c('service-fail',{ref:"serviceFailModal",on:{"show-modal":function($event){_vm.showServiceFail = $event}}}),_c('chatbot')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }